var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgXButton({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 31,
    height: 31,
    rx: 15.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 31,
    height: 31,
    rx: 15.5,
    stroke: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.4967 9.4967C9.71366 9.27974 10.0654 9.27974 10.2824 9.4967L16.0007 15.215L21.7189 9.4967C21.9359 9.27975 22.2876 9.27975 22.5046 9.4967C22.7216 9.71366 22.7216 10.0654 22.5046 10.2824L16.7863 16.0007L22.5046 21.7189C22.7216 21.9359 22.7216 22.2876 22.5046 22.5046C22.2876 22.7216 21.9359 22.7216 21.7189 22.5046L16.0007 16.7863L10.2824 22.5046C10.0654 22.7216 9.71366 22.7216 9.4967 22.5046C9.27974 22.2876 9.27974 21.9359 9.4967 21.7189L15.215 16.0007L9.4967 10.2824C9.27974 10.0654 9.27974 9.71366 9.4967 9.4967Z",
    fill: "#23242A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXButton);
export default __webpack_public_path__ + "static/media/x-button.a34060bd30175d5cb196c00a49bd133d.svg";
export { ForwardRef as ReactComponent };